import { Money } from "classes/DecimalClasses";

export function afterGet(record) {
  const newRecord = { ...record };
  newRecord.costBasis = new Money(newRecord.costBasis);
  return newRecord;
}
